import React from 'react'

import { GeneralInputType } from '@/types'

interface GeneralInputProps {
  type: GeneralInputType
  extendClass?: boolean
  className?: string
  placeholder?: string
  defaultValue?: string
  required?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  updateValueOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: number | string
  readOnly?: boolean
  disabled?: boolean
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  autoFocus?: boolean
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  maxLength?: number
}

const DefaultStyle =
  'block w-full rounded-lg border bg-white h-12 px-4 py-2.5 font-light sm:text-base sm:leading-6 focus:outline-none'

const GeneralInput: React.FC<GeneralInputProps> = ({
  type,
  extendClass = false,
  className,
  placeholder,
  defaultValue,
  required,
  onChange,
  updateValueOnChange,
  value,
  readOnly = false,
  disabled = false,
  onBlur,
  autoFocus = false,
  onFocus,
  onKeyDown,
  maxLength,
}) => {
  return (
    <input
      type={type}
      className={extendClass ? className + ' ' + DefaultStyle : className || DefaultStyle}
      defaultValue={defaultValue}
      value={value}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      disabled={disabled}
      onChange={(e) => {
        updateValueOnChange && updateValueOnChange(e)
        onChange && onChange(e)
      }}
      onBlur={onBlur}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
    />
  )
}

export default GeneralInput
